import React from 'react'

import { ZariContext } from '_zari/context'
import { Table, Col, Row, Button, Divider } from '_zari/core'

import { NuevoActualizarDetalleSeguimientoModal } from 'sharedComponents/modals'

import * as SociosSeguimientoService from 'services/sociosSeguimiento.service'

const TablaDetallesSection = ({ idSeguimiento }) => {
  const __zariContext = React.useContext(ZariContext)

  const modalDataRef = React.useRef({})

  const [listaDetalles, setListaDetalles] = React.useState([])
  const [mostrarNuevoActualizarModal, setMostrarNuevoActualizarModal] = React.useState(false)

  const actualizarLista = React.useCallback(() => {
    SociosSeguimientoService.obtenerTodoDetallesxId(idSeguimiento)
      .then(({ data }) => setListaDetalles(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [idSeguimiento, __zariContext])

  React.useEffect(() => {
    actualizarLista()
  }, [actualizarLista])

  const clickNuevo = React.useCallback(() => {
    modalDataRef.current = {}
    setMostrarNuevoActualizarModal(true)
  }, [])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      SociosSeguimientoService.obtenerDetallexIdDetalleAsEdicion(idSeguimiento, _id)
        .then(({ data }) => {
          modalDataRef.current = data
          setMostrarNuevoActualizarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [idSeguimiento, __zariContext]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      SociosSeguimientoService.eliminarDetallexIdDetalle(idSeguimiento, _id)
        .then(({ data }) => {
          __zariContext.snack('success', 'El detalle se ha eliminado.')
          actualizarLista()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [idSeguimiento, __zariContext, actualizarLista]
  )

  const onCreate = React.useCallback(() => {
    actualizarLista()
    setMostrarNuevoActualizarModal(false)
  }, [actualizarLista])

  return (
    <>
      <Divider />
      <Row>
        <Col md={12}>
          <Row>
            <Col md={12} className='mb-2 text-right'>
              <Button onClick={clickNuevo}>Nuevo</Button>
            </Col>
          </Row>
          <Table
            filas={listaDetalles}
            headRows={[{ width: 130, label: 'FECHA' }, { label: 'COMENTARIO' }, { width: 30, label: '' }]}
            maxRowsShown={10}
            rowTemplate={(row, key) => (
              <Table.Row key={key}>
                <Table.Cell align='center'>{row.fecha || '--'}</Table.Cell>
                <Table.Cell>{row.comentario || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Col>
      </Row>
      {mostrarNuevoActualizarModal && (
        <NuevoActualizarDetalleSeguimientoModal
          handleClose={() => setMostrarNuevoActualizarModal(false)}
          idSeguimiento={idSeguimiento}
          onCreate={onCreate}
          show={mostrarNuevoActualizarModal}
          modalData={modalDataRef.current}
        />
      )}
    </>
  )
}

export default React.memo(TablaDetallesSection)
